
import { FC } from 'react';
import { motion } from 'framer-motion';

export const CommunityHero: FC = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="text-center mb-8"
    >
      <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 dark:text-white sm:text-5xl md:text-6xl">
        <span className="block text-indigo-700 dark:text-indigo-400">Begin Your Sleep Journey</span>
      </h1>
      <p className="mt-3 max-w-md mx-auto text-base text-gray-700 dark:text-gray-300 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
        Download the SleepNest mobile app to track your child's sleep, connect with sleep specialists, and get personalized guidance on the go.
      </p>
    </motion.div>
  );
};
